// extracted by mini-css-extract-plugin
module.exports = {"Btn":"Button_Btn__MRf89","light":"Button_light__1IvRA","dark":"Button_dark__2mXdD"};